import {FC, ReactNode} from 'react';
import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSettingsContext } from '../context/settings/useSettingsContext';
import { ImageViewMode } from '../enums/ImageViewMode';

const Card = styled.div`
`;

const Image = styled.div`
`;

const StyledLazyLoadImage = styled(LazyLoadImage)`
    display: flex !important;

    &:not(.lazy-load-image-loaded) img {
        display: none;
    }
`;

const Content = styled.div`
`;

type TProps = {
    imageSrc?: string;
    placeholderSrc?: string;
    imageAlt: string;
    children: ReactNode;
    maintainAspect?: boolean;
}

const onError = () => {
    console.log('error');
    console.log(this);
    // @ts-ignore
    this.effect = undefined;
}

const ImageCard: FC<TProps> = ({imageSrc, placeholderSrc, imageAlt, children, maintainAspect}) => {
    const { imageViewMode } = useSettingsContext();

    const isArched = (imageViewMode === ImageViewMode.Arched);

    return (
        <Card className="cr-image-card cr-flex cr-flex-col cr-bg-grey-light cr-shadow cr-rounded-block cr-h-100">
            <Image className="cr-image-wrapper cr-flex">
                <StyledLazyLoadImage
                    wrapperClassName={`cr-w-100 cr-rounded-block-top ${maintainAspect ? 'cr-aspect-video' : ''} ${isArched ? 'cr-masked' : ''}`}
                    className={`cr-w-100 ${maintainAspect ? 'cr-aspect-video' : ''} ${isArched ? '' : 'cr-rounded-block-top'}`}
                    alt={imageAlt}
                    src={imageSrc ?? undefined}
                    placeholderSrc={placeholderSrc}
                    effect={imageSrc ? 'blur' : undefined}
                />
            </Image>
            <Content className="cr-flex cr-flex-col cr-content-wrapper cr-h-100">
                {children}
            </Content>
        </Card>
    );
};

export default ImageCard;
